module.exports = __webpack_public_path__ + "static/media/AES_eBike_Akku_04.ece5038d.png";